// scroll-position.service.ts
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ScrollPositionService {

    private map = new Map<string, any>();

    set(selectedYear: any, selectedView: any, accomplishmentPlanId: any,  selectedPlanIndex: any, url: any, pos: number) { 
        
        this.map.set(url, {'pos': pos, 'accomplishmentPlanId': accomplishmentPlanId, 'selectedPlanIndex': selectedPlanIndex, 'selectedYear': selectedYear, 'selectedView': selectedView}); 
        //console.log('Position set: ' + pos + ' for ' + url );
    
    }

    get(url: string): any { 
        //console.log('Position get: ' + this.map.get(url) + ' for ' + url );
        return this.map.get(url) ?? 0; 
       
    }
}
